import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

export const useShurjoPay = (data) => {


    const shurjoPayData = data;
    const [shurjoBuffer, setShurjoBuffer] = useState(false)
    let history = useHistory()


    const shurjoPayMakePayment = () => {

        

        setShurjoBuffer(true)


        axios.post("/api/initiata-shurjo-payment", shurjoPayData).then(async (res) => {
            setShurjoBuffer(false)
            history.push({
                pathname: '/surya-pay',

                state: {
                    url: res?.data?.checkout_url
                }// your data array of objects
            })
        }).catch(err => {
            setShurjoBuffer(false)
        });


    }

    return { shurjoPayMakePayment, shurjoBuffer }
}
